import { Text } from "@chakra-ui/react";
import React from "react";
const ValidationError = (props) => {
    return ( 
        <Text maxWidth='250px' fontSize='xs' color='red' pl={2}> {props.text} </Text>
     );
}
 
export default ValidationError;